import type { QueryClient } from '@tanstack/react-query';
import { Link, Outlet, createRootRouteWithContext } from '@tanstack/react-router';
import { ApiHealth } from '../components/ApiHealth';
import { SessionGate } from '../components/SessionGate';
import { OperatorChip } from '../components/OperatorChip';
import logo from '../assets/platformctl.svg';

export interface RouterContext {
  queryClient: QueryClient;
}

export const Route = createRootRouteWithContext<RouterContext>()({
  component: RootLayout,
});

function RootLayout() {
  return (
    <div className="app">
      <header className="app-header">
        {/*
          * The one place colour is not carrying state. Everywhere else in this
          * console a hue means something is running, locked, refused or
          * abandoned; the wordmark is identity, so it stays in the chrome and
          * never appears beside operational data.
          */}
        <Link to="/" className="brand" aria-label="Platform Control — home">
          <img src={logo} alt="platformctl" />
        </Link>
        <nav>
          <Link to="/accounts" activeProps={{ className: 'active' }}>Accounts</Link>
          <Link to="/lxc" activeProps={{ className: 'active' }}>Containers</Link>
          <Link to="/audit" activeProps={{ className: 'active' }}>Audit</Link>
          <Link to="/jobs" activeProps={{ className: 'active' }}>Jobs</Link>
        </nav>

        <OperatorChip />
      </header>

      <main className="app-main">
        {/*
          * A sibling of the gate, never a child of it. `<SessionGate>` replaces
          * everything below on a failed `/api/auth/me`, and `/api/health` is
          * the one endpoint in the contract that needs no session — so the
          * moment this reading is worth having is precisely the moment the gate
          * would have swallowed it. It renders nothing at all while the API is
          * well (see `ApiHealth`), so above the outlet costs no space until it
          * has something to say.
          */}
        <ApiHealth />

        <SessionGate>
          <Outlet />
        </SessionGate>
      </main>
    </div>
  );
}
